import React, { useState } from 'react'
import { LIBERTY_IMAGES } from '../assets/asset'
import { useNavigate } from 'react-router-dom'
import TokenSelector from '../components/TokenSelector'
import { useWalletUI } from '../hooks/useWalletUI'
import useApproval from '../hooks/useApproval'

const LIQUIDITY_TOKEN_INIT = {
    symbol: 'USDC',
    chain: 'PulseChain',
    image: LIBERTY_IMAGES.USDC,
    chainBadge: LIBERTY_IMAGES.PULSECHAIN,
}

const LiquidityW = () => {
    const navigate = useNavigate()
    const [tokenSelectorOpen, setTokenSelectorOpen] = useState(false)
    const [selectedToken, setSelectedToken] = useState(LIQUIDITY_TOKEN_INIT)
    const { isConnected, openConnectModal } = useWalletUI()
    const { approveContract, isApproveLoading } = useApproval()
    return (
        <>
            <main className="pt-16 md:pt-20 pb-16 md:pb-0">
                {/*$*/}
                {/*/$*/}
                <div className="flex md:justify-center md:items-center md:min-h-screen">
                    <div className="backdrop-blur-md md:rounded-2xl p-4 md:p-6 w-full max-w-[600px] bg-[#18181B] border border-white/[0.03]">
                        <div className="flex justify-center items-center mb-6 text-center py-2 pt-5 md:pt-2">
                            <img
                                alt="Liquidity"
                                loading="lazy"
                                width={200}
                                height={0}
                                decoding="async"
                                data-nimg={1}
                                src={LIBERTY_IMAGES.LIQUIDITY}
                                style={{ color: "transparent" }}
                            />
                        </div>
                        <div className="flex bg-[#242429] rounded-full p-1 w-full mb-5">
                            <button onClick={() => navigate('/liquidity')} className="w-1/2 px-4 py-2.5 rounded-full transition-all duration-200 text-gray-400 hover:text-white">
                                Add
                            </button>
                            <button onClick={() => navigate('/liquidity-withdraw')} className="w-1/2 px-4 py-1.5 rounded-full transition-all duration-200 text-white bg-[#393941]">
                                Withdraw
                            </button>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <div className="bg-[#242429] rounded-2xl p-3 md:p-4">
                                    <div className="flex justify-between gap-4 mb-4">
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-400 text-sm">Withdraw amount</span>
                                        </div>
                                    </div>
                                    <div className="flex justify-between gap-4">
                                        <div className="w-1/2">
                                            <div className="relative w-full">
                                                <input
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]*"
                                                    placeholder={0}
                                                    className="bg-transparent outline-none w-full font-semibold  text-3xl font-semibold w-full"
                                                    type="text"
                                                    defaultValue=""
                                                />
                                            </div>
                                            <div className="flex items-center gap-1 mt-2">
                                                <img
                                                    alt={selectedToken.symbol}
                                                    loading="lazy"
                                                    width={15}
                                                    height={15}
                                                    decoding="async"
                                                    data-nimg={1}
                                                    className="rounded-full"
                                                    src={selectedToken.image}
                                                    style={{ color: "transparent" }}
                                                />
                                                <span>{selectedToken.symbol}</span>
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-end gap-3">
                                            <div>
                                                <div
                                                    onClick={() => setTokenSelectorOpen(true)}
                                                    className="inline-flex flex-col items-center justify-between bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] py-1.5 md:py-1 px-2 rounded-full cursor-pointer hover:bg-[#333333]
  font-medium whitespace-nowrap self-start bg-[#393941]!"
                                                >
                                                    <div className="flex items-center gap-2 w-full">
                                                        <div className="flex items-center w-full">
                                                            <div className="relative mr-2">
                                                                <img
                                                                    alt={selectedToken.symbol}
                                                                    loading="lazy"
                                                                    width={32}
                                                                    height={32}
                                                                    decoding="async"
                                                                    data-nimg={1}
                                                                    className="border border-[#393941] rounded-full"
                                                                    src={selectedToken.image}
                                                                    style={{ color: "transparent" }}
                                                                />
                                                                <div className="absolute -bottom-1 -right-1">
                                                                    <img
                                                                        alt={selectedToken.chain}
                                                                        loading="lazy"
                                                                        width={16}
                                                                        height={16}
                                                                        decoding="async"
                                                                        data-nimg={1}
                                                                        className="border border-[#393941] rounded-full"
                                                                        src={selectedToken.chainBadge}
                                                                        style={{ color: "transparent" }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="flex flex-col items-start md:mr-2">
                                                                <span className="text-[#F7F7F8] font-medium text-base">
                                                                    {selectedToken.symbol}
                                                                </span>
                                                                <span className="text-[#9091A0] text-xs md:block hidden">
                                                                    {selectedToken.chain}
                                                                </span>
                                                            </div>
                                                            <img
                                                                alt="Chevron Down"
                                                                loading="lazy"
                                                                width={20}
                                                                height={20}
                                                                decoding="async"
                                                                data-nimg={1}
                                                                className="ml-auto flex-shrink-0"
                                                                src={LIBERTY_IMAGES.IC_CHEVRON_DOWN}
                                                                style={{ color: "transparent" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-6">
                                    <button
                                        className="rounded-xl font-medium transition-all duration-300 cursor-pointer text-white hover:opacity-90 px-6 py-3 text-base w-full   "
                                        style={{ background: "var(--gradient-1)" }}
                                        type="button"
                                        onClick={() => {
                                            if (!isConnected) {
                                                openConnectModal?.()
                                                return
                                            }
                                            approveContract()
                                        }}
                                        disabled={isConnected && isApproveLoading}
                                    >
                                        {isConnected ? (isApproveLoading ? 'Processing...' : 'Swap') : 'Connect Wallet'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <TokenSelector
                full={false}
                open={tokenSelectorOpen}
                onClose={() => setTokenSelectorOpen(false)}
                onSelect={(sel) =>
                    setSelectedToken({
                        symbol: sel.symbol,
                        chain: sel.chain,
                        image: sel.image,
                        chainBadge: sel.chainBadge,
                    })
                }
            />
        </>
    )
}

export default LiquidityW